/**
 * Вспомогательная функция для создания debounce.
 * Предотвращает частые вызовы функции за короткий интервал времени.
 *
 * @param func - Функция, которую нужно обернуть в debounce.
 * @param wait - Задержка в миллисекундах.
 * @returns - Декорированная функция с дебаунсом и методом cancel.
 */
export default function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): T & { cancel: () => void } {
  let timeout: number | null = null;

  const debounced = ((...args: any[]) => {
    if (timeout) clearTimeout(timeout);
    timeout = window.setTimeout(() => func(...args), wait);
  }) as T & { cancel: () => void };

  debounced.cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}
